import React, { useEffect, useRef, useState } from "react";
import { BtnRightArrow } from "../constants/svgPath";
import imagePath from "../constants/imagePath";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import staticStrings from "../constants/staticStrings";

function BannerAnimatedContent({
  typingSpeed = 100,
  deletingSpeed = 60,
  pauseAfterTyped = 1500,
  loop = true,
  className = "",
}) {
  const textArray = Array.isArray(staticStrings.bannerAnimatedTexts)
    ? staticStrings.bannerAnimatedTexts
    : String(staticStrings.bannerAnimatedTexts)
        .split(",")
        .map((s) => s.trim());

  const [display, setDisplay] = useState("");
  const stringIndexRef = useRef(0);
  const charIndexRef = useRef(0);
  const isTypingRef = useRef(true);
  const pauseRef = useRef(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    function clearTimer() {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }

    function tick() {
      const sIdx = stringIndexRef.current;
      const current = textArray[sIdx] ?? "";
      if (isTypingRef.current) {
        // TYPING
        if (charIndexRef.current < current.length) {
          charIndexRef.current += 1;
          setDisplay(current.slice(0, charIndexRef.current));
          timerRef.current = setTimeout(tick, typingSpeed);
        } else {
          // finished typing this string
          pauseRef.current = true;
          timerRef.current = setTimeout(() => {
            pauseRef.current = false;
            isTypingRef.current = false; // start deleting
            tick();
          }, pauseAfterTyped);
        }
      } else {
        // DELETING
        if (charIndexRef.current > 0) {
          charIndexRef.current -= 1;
          setDisplay(current.slice(0, charIndexRef.current));
          timerRef.current = setTimeout(tick, deletingSpeed);
        } else {
          // finished deleting, move to next string
          isTypingRef.current = true;
          stringIndexRef.current = stringIndexRef.current + 1;
          if (stringIndexRef.current >= textArray.length) {
            stringIndexRef.current = 0;
            if (!loop) {
              // if not looping, stop entirely (ensure display is empty)
              clearTimer();
              return;
            }
          }
          // small pause before typing next (you can remove or adjust)
          timerRef.current = setTimeout(tick, typingSpeed);
        }
      }
    }

    // start ticking
    timerRef.current = setTimeout(tick, typingSpeed);

    return () => {
      // cleanup on unmount or prop change
      clearTimer();
    };
    // We intentionally include only the props that should restart effect when changed:
  }, [textArray, typingSpeed, deletingSpeed, pauseAfterTyped, loop]);
  return (
    <div>
      <h1>
        Turning Ideas Into Digital Solutions
        <span className={"blk animatedText"} aria-live="polite">
          {display}
        </span>
      </h1>
      <p className="banner_txt">
        We partner with businesses to design, build, and scale high-impact
        digital products. Our custom software solutions combine innovation,
        precision engineering, and long-term strategic thinking.
      </p>
    </div>
  );
}

export default BannerAnimatedContent;
